/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { REWARD_TYPE } from '../../constants'

export const REWARD_MEDAL_TOOLTIPS = {
    [REWARD_TYPE.MEDAL_FIRST]: {
        title: (
            <FormattedMessage
                id='reward.tooltips.medal.first.title'
                defaultMessage='Медаль «Победитель I степени»'
            />
        ),
        message: (
            <FormattedMessage
                id='reward.tooltips.medal.first.body'
                defaultMessage='Занять первое место по итогам сезона на уровне техники X на Глобальной карте.'
            />
        ),
    },
    [REWARD_TYPE.MEDAL_SECOND]: {
        title: (
            <FormattedMessage
                id='reward.tooltips.medal.second.title'
                defaultMessage='Медаль «Победитель II степени»'
            />
        ),
        message: (
            <FormattedMessage
                id='reward.tooltips.medal.second.body'
                defaultMessage='Занять второе место по итогам сезона на уровне техники X на Глобальной карте.'
            />
        ),
    },
    [REWARD_TYPE.MEDAL_THIRD]: {
        title: (
            <FormattedMessage
                id='reward.tooltips.medal.third.title'
                defaultMessage='Медаль «Победитель III степени»'
            />
        ),
        message: (
            <FormattedMessage
                id='reward.tooltips.medal.third.body'
                defaultMessage='Занять третье место по итогам сезона на уровне техники X на Глобальной карте.'
            />
        ),
    },
    [REWARD_TYPE.MEDAL_ELITE]: {
        title: (
            <FormattedMessage
                id='reward.tooltips.medal.elite.title'
                defaultMessage='Медаль «Элита»'
            />
        ),
        message: (
            <FormattedMessage
                id='reward.tooltips.medal.elite.body'
                defaultMessage='Войти в 10% лучших кланов по итогам сезона на уровне техники X на Глобальной карте.'
            />
        ),
    },
    [REWARD_TYPE.MEDAL_VETERAN]: {
        title: (
            <FormattedMessage
                id='reward.tooltips.medal.veteran.title'
                defaultMessage='Медаль «Ветеран»'
            />
        ),
        message: (
            <FormattedMessage
                id='reward.tooltips.medal.veteran.body'
                defaultMessage='Войти в 50% лучших кланов по итогам сезона на уровне техники X на Глобальной карте.'
            />
        ),
    },
}



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/RewardTooltip/translations.jsx